<template>
    <div class="maincontainer">
        <taskform :ntask="ntask"  :loaded="loaded" v-on:saveTask="saveTaskClicked(ntask)" :customers="customersList" :workerItems="workerItems" :workersLoaded="workersLoaded" ref="taskform"></taskform>
        <table>
            <thead style="position: sticky; top: 100px;">
                <tr>
                    <th style="width: 5%;">
                        <p v-on:click="set_order('customer_number')" class="cursor-pointer">
                        <span>{{$t('customers.number')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'customer_number' && order == 'asc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'customer_number' && order == 'desc'">arrow_drop_up</i>
                        </p>
                        <div class="input-field col s6">
                            <input id="name" type="text" class="validate" v-model="numbersearch">
                        </div>
                    </th>
                    <th style="width: 25%;">
                        <p v-on:click="set_order('name')" class="cursor-pointer">
                            <span>{{$t('places.name')}}</span>
                            <i class="material-icons dp6" v-if="orderby == 'name' && order == 'asc'">arrow_drop_down</i>
                            <i class="material-icons dp6" v-if="orderby == 'name' && order == 'desc'">arrow_drop_up</i>
                        </p>
                        <div class="input-field col s6">
                            <input id="name" type="text" class="validate" v-model="namesearch">
                        </div>
                    </th>
                    <th style="text-align: center;" v-for="devc in devcats" :title="devc.name" v-on:click="set_order('countgroups:'+devc.id)" class="cursor-pointer">
                        {{devc.prefix}}
                        <i class="material-icons dp6" v-if="orderby == 'countgroups' && order == 'asc' && ordid == devc.id">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'countgroups' && order == 'desc' && ordid == devc.id">arrow_drop_up</i>
                    </th>
                    <th v-on:click="set_order('last_inspected')" class="cursor-pointer">
                        <span> {{$t('places.last_inspection')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'last_inspected' && order == 'asc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'last_inspected' && order == 'desc'">arrow_drop_up</i>
                        <div class="input-field col s6">
                        </div>
                    </th>
                    <th v-on:click="set_order('next_inspection')" class="cursor-pointer">
                        <span> {{$t('places.planned_next_inspection')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'next_inspection' && order == 'asc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'next_inspection' && order == 'desc'">arrow_drop_up</i>
                        <div class="input-field col s6">
                        </div>
                    </th>
                    <th style="width: 15%;">
                        <p  v-on:click="set_order('status')" class="cursor-pointer">
                            <span>{{$t('customers.status')}}</span>
                            <i class="material-icons dp6" v-if="orderby == 'status' && order == 'asc'">arrow_drop_down</i>
                            <i class="material-icons dp6" v-if="orderby == 'status' && order == 'desc'">arrow_drop_up</i>
                        </p>
                        <div class="input-field col s12">
                            <select multiple="true" v-model="status">
                                <option value="" disabled selected>Status</option>
                                <option value="active">{{$t('places.active')}}</option>
                                <option value="inactive">{{$t('places.inactive')}}</option>
                                <option value="suspended">{{$t('places.suspended')}}</option>
                            </select>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody v-if="loaded">
                <template v-for="(place, index) in listItems">
                    <tr :class="place.status == 'active' ? '' : 'grayed'" >
                        <td>{{place.customer_number}}</td>
                        <td>
                            <router-link :to="{ name: 'place', params: { customer_id: place.customer_id, place_id: place.id }}">
                                {{!!place.name ? place.name :  $t('places.no_name')  }}
                            </router-link>
                        </td>
                        <td v-for="devc in devcats" style="text-align: center; padding-left: 5px;"><template v-if="place.countgroups[devc.id] != undefined">{{place.countgroups[devc.id].quantity}}</template><template v-if="place.countgroups[devc.id] == undefined">0</template></td>
                        <td>
                            <div>{{place.last_inspected * 1000 | formatDate}}</div>
                        </td>
                        <td>
                            <div class="cursor-pointer" v-if="place.next_inspection_task"  v-bind:class="{ 'overdue': place.overdone }" v-on:click="showTask(place.next_inspection_task)">{{place.next_inspection * 1000 | formatDate}}</div>
                            <div v-bind:class="{ 'overdue': place.overdone }" v-else-if="place.status == 'active' && role != 'ddd_customer'">
                                <button class="btn btn-small green" v-on:click="planInspection(place)">{{$t('menu.buttons.plan_inspection')}}</button>
                                <template v-if="place.earliest_planned_inspection != null"><br/>({{place.earliest_planned_inspection.format("D.M.YYYY")}})</template>
                            </div>
                        </td>
                        <td style="text-transform: uppercase;">{{place.status == "active" ? $t('places.active') : $t('places.inactive')}}</td>
                    </tr>
                </template>
            </tbody>
            <preloader v-if="loaded == false" :n="5 + devcats.length" />
        </table>
    </div>
</template>
<script>
import Vue2Filters from 'vue2-filters'
import axios from 'axios';
import moment from 'moment';
import _ from 'lodash';
export default {
    data: function() {
        return {
            order: 'asc',
            orderby: 'number',
            places: [],
            timestamp: 0,
            workersTimestamp: 0,
            deviceCategoriesTimestamp: 0,
            devsLoaded: false,
            loaded: false,
            namesearch: "",
            addressearch: "",
            numbersearch: "",
            status: ['active'],
            devcats: [],
            workerItems: [],
            workersLoaded: false,
            selectedTags: [],
            placesDict: {},
            workers: [],
            lastInspectiondateRange: { 
              startDate: moment().startOf('year').format(),
              endDate: moment().endOf('year').format()
            },
            nextInspectiondateRange: { 
              startDate: moment().startOf('year').format(),
              endDate: moment().endOf('year').format()
            },
            ntask: undefined,
            ordid: undefined
        }
    },
    props: { role: { type: String, default: function(){
        return 'ddd_customer';
    } } },
    mounted() {

        if(_.isUndefined(this.$parent.state.places) == false){
            this.order = this.$parent.state.places.order;
            this.ordid = this.$parent.state.places.ordid;
            this.orderby = this.$parent.state.places.orderby;
            this.namesearch = this.$parent.state.places.namesearch;
            this.numbersearch = this.$parent.state.places.numbersearch;
            this.status = this.$parent.state.places.status;
            this.loaded = this.$parent.state.places.loaded;
            this.places = this.$parent.state.places.items;
            this.placesDict = this.$parent.state.places.placesDict;
            this.timestamp = this.$parent.state.places.timestamp;
            this.workersLoaded = this.$parent.state.workers.loaded;
            this.workers = this.$parent.state.workers.items;
            this.workersTimestamp = this.$parent.state.workers.timestamp;
            this.devsLoaded = this.$parent.state.device_categories.loaded;
            this.devcats = this.$parent.state.device_categories.items;
            this.deviceCategoriesTimestamp = this.$parent.state.device_categories.timestamp;
            this.$forceUpdate();
        }
        this.fetch_places(); 
    },
    beforeRouteLeave (to, from , next) {
        this.$emit('commitState', { 
          places: {
            order: this.order,
            ordid: this.ordid,
            orderby: this.orderby,
            namesearch: this.namesearch,
            numbersearch: this.numbersearch,
            status: this.status,
            items: this.places,
            placesDict: this.placesDict,
            loaded: this.loaded,
            timestamp: this.timestamp
        },
        workers: {
            items: this.workers,
            loaded: this.workersLoaded,
            timestamp: this.workersTimestamp
        },
        device_categories: {
            items: this.devcats,
            loaded: this.devsLoaded,
            timestamp: this.deviceCategoriesTimestamp
        }
        }
       );
        next();
    },
    methods: {
        fetch_places: async function() {
            var response = await axios.get('/places.json')
            this.places = response.data;
            for (var i in this.places) {
                this.places[i].collapsed = false;
                this.places[i].address_text =  "" + this.places[i].address.street + ""
                var place = this.places[i];
                place.orders_groupped = _.keyBy(place.orders, 'dev_type_id');
                place.plans_groupped = _.keyBy(place.planned, 'dev_type_id');
                place.earliest_planned_inspection = null;
                for (const key in place.plans_groupped) {
                      if (place.plans_groupped.hasOwnProperty(key)) {
                        var interval = null; // Default to 30 days
                        if(place.orders_groupped.hasOwnProperty(key) && place.orders_groupped[key].interval != null) interval = place.orders_groupped[key].interval;
                        if(place.plans_groupped[key].last_inspected != null && interval != null){
                            const currentValue = moment(place.plans_groupped[key].last_inspected).add(interval);

                            if (place.earliest_planned_inspection === null || currentValue.isBefore(place.earliest_planned_inspection)) {
                              place.earliest_planned_inspection = currentValue;
                            }
                        }
                    }
                }
                this.places[i].countgroups = _.keyBy(this.places[i].counts, 'device_category');
                if(this.places[i].next_inspection == null && place.earliest_planned_inspection != null){
                    this.places[i].next_inspection = place.earliest_planned_inspection.unix();
                }
                if(moment(this.places[i].next_inspection * 1000).isSameOrAfter(moment(), 'day')){
                    this.places[i].overdone = false
                }else{
                    this.places[i].overdone = true
                }
            }   
            this.placesDict = _.keyBy(this.places, 'id');
            response = await axios.get('/device_categories.json');
            this.devcats = response.data;
            this.devsLoaded = true;
            if(this.role != "ddd_customer"){
            var ts = _.now();
            response = await axios.get('/workers.json')
            this.workersTimestamp = ts
                this.workers = response.data;
                for (var i in this.workers) {
                    var item = this.workers[i];
                    if (item.active == true) {
                        this.workerItems.push({ value: item.id, name: item.name + " " + item.surname, symbol: item.symbol });
                    }
                }
            }
            this.loaded = true;
            this.workersLoaded = true;
        },
        async fetchPlacesData() {
          const lastResponse = await axios.get('/places/last.json');
          const lastServerTimestamp = lastResponse.data * 1000; // Assuming the server returns a timestamp

          if (!this.timestamp || this.timestamp < lastServerTimestamp) {
            const response = await axios.get('/places.json');
            this.timestamp = _.now();
            this.places = response.data;

            for (const place of this.places) {
              place.collapsed = false;
              place.address_text = `${place.address.street}`;
              place.orders_groupped = _.keyBy(place.orders, 'dev_type_id');
              place.plans_groupped = _.keyBy(place.planned, 'dev_type_id');
              place.earliest_planned_inspection = null;

              for (const key in place.plans_groupped) {
                if (place.plans_groupped.hasOwnProperty(key)) {
                  let interval = 30 * 24 * 60 * 60 * 1000; // Default to 30 days
                  if (place.orders_groupped[key]?.interval != null) {
                    interval = place.orders_groupped[key].interval;
                  }
                  if (place.plans_groupped[key].last_inspected != null) {
                    const currentValue = moment(place.plans_groupped[key].last_inspected).add(interval);
                    if (!place.earliest_planned_inspection || currentValue.isBefore(place.earliest_planned_inspection)) {
                      place.earliest_planned_inspection = currentValue;
                    }
                  }
                }
              }

              if (!place.next_inspection && place.earliest_planned_inspection) {
                place.next_inspection = place.earliest_planned_inspection.unix();
              }

              place.countgroups = _.keyBy(place.counts, 'device_category');
              place.overdone = !moment(place.next_inspection * 1000).isSameOrAfter(moment(), 'day');
            }

            this.placesDict = _.keyBy(this.places, 'id');
          }
        },

        collapse: function(customer) {
            customer.collapsed = !(customer.collapsed);
            this.$forceUpdate();
        },
        set_order: function(order) {
            var ord = order
            this.ordid = undefined;
            if(order.split(":").length > 1){
                ord = order.split(":")[0];
                this.ordid = order.split(":")[1];
            }
            if (this.orderby == ord) {
                if (this.order == 'desc') {
                    this.order = 'asc'
                } else if (this.order == 'asc') {
                    this.order = 'desc'
                }
            } else {
                this.order = 'asc'
                this.orderby = ord;
            }
        },
         saveTaskClicked: async function(task) {
            await this.saveTask(task)
            if (this.instances != undefined) {
                if(!_.isUndefined(this.instances[0])) this.instances[0].close()
            }
        },
        saveTask: async function(task) {
            if(moment(task.startsAt).isAfter(task.endsAt)){
                return false;
            } 
            const formData = new FormData();
            formData.append('task[startsAt]', moment(task.startsAt).utcOffset(1, false).format('YYYY-MM-DDTHH:mmZZ'));
            formData.append('task[endsAt]', moment(task.endsAt).utcOffset(1, false).format('YYYY-MM-DDTHH:mmZZ'));
            formData.append('task[typeof]', task.typeof);
            formData.append('task[payment_method]', task.payment_method || "cash");
            formData.append('task[pricing]', task.pricing);
            if (task.routine) formData.append('task[routine]', true);
            formData.append('task[name]', task.name || "");
            formData.append('task[status]', task.status);
            formData.append('task[reconescance]', task.reconescance);
            formData.append('task[physical_mount]', task.physical_mount);
            formData.append('task[intervention_type_other]', task.intervention_type_other);
            formData.append('task[typeof_other]', task.typeof_other);
            if (_.isUndefined(task.worker_ids) == false) {
                for (var index in _.range(0, task.worker_ids.length)) {
                    var worker_id = task.worker_ids[index];
                    if(worker_id != -1){
                        formData.append('task[worker_ids][]', worker_id);
                    }
                }
            }
            if (_.isUndefined(task.photos) == false) {
                for (var index in _.range(0, task.photos.length)) {
                    formData.append('task[media_attributes][' + index + '][image]', task.photos[index].attachment);
                    if (task.photos[index].id) {
                        formData.append('task[media_attributes][' + index + '][id]', task.photos[index].id);
                    }
                    if (task.photos[index].destroy) {
                        formData.append('task[media_attributes][' + index + '][_destroy]', true);
                    }
                }
            }
            if (task.typeof == 'intervention') formData.append('task[intervention_type]', task.intervention_type);
            if(_.isUndefined(task.phone_number) == false){
                formData.append('task[phone_number]', task.phone_number);
            }
            if (task.routine == false && (task.typeof == 'other' || task.typeof == 'intervention')) {
                formData.append('task[address_attributes][name]', task.address.name);
                formData.append('task[address_attributes][street]', task.address.street);
                formData.append('task[address_attributes][city]', task.address.city);
                formData.append('task[address_attributes][postal_code]', task.address.postal_code);
            } else {
                formData.append('task[place_id]', task.place_id);
            }
            if (task.id) {
                var response = await axios.put('/tasks/' + task.id + '.json', formData)
                var task = _.cloneDeep(response.data)
            } else {
                var response = await axios.post('/tasks.json', formData)
                var task = _.cloneDeep(response.data)   
            }
            task.startsAt = moment(task.startsAt).format('YYYY-MM-DDTHH:mm')
            task.endsAt = moment(task.endsAt).format('YYYY-MM-DDTHH:mm')
            this.placesDict[task.place_id].next_inspection = moment(task.startsAt).unix()
            this.placesDict[task.place_id].next_inspection_task = task.id;
            this.$refs.taskform.saving = false;
        },
        planInspection: function(place){
            this.ntask = {
                typeof: 'inspection',
                status: 'no_date',
                place_id: place.id,
                routine: false,
                worker_ids: [],
                startsAt: moment().format('YYYY-MM-DDTHH:mm'),
                endsAt: moment().add(1, 'hour').format('YYYY-MM-DDTHH:mm'),
                address: {
                    name: "",
                    street: "",
                    city: "",
                    postal_code: ""
                },
                phone_number: "",
                reconescance: "",
                photos: [],
                edit: true
            };
            var elems = document.querySelectorAll('.modal');
            this.instances = M.Modal.init(elems, { startingTop: '0%', preventScrolling: true, });
            if(!_.isUndefined(this.instances[0])) this.instances[0].open()
        },
         showTask: async function(taskid){
          var resp = await axios.get("/tasks/"+taskid+".json")
          resp.data.edit = false
          this.ntask = resp.data
          var elems = document.querySelectorAll('.modal');
          this.instances = M.Modal.init(elems, { startingTop: '0%', preventScrolling: true, });
          if(!_.isUndefined(this.instances[0])) this.instances[0].open()
        },
    },
    computed: {
        listItems() {
            var that = this;
            const range = moment.range(
                moment(this.lastInspectiondateRange.startDate),
                moment(this.lastInspectiondateRange.endDate)
            );
            const next_range = moment.range(
                moment(this.nextInspectiondateRange.startDate),
                moment(this.nextInspectiondateRange.endDate)
            );
            return _.filter(
                _.orderBy(this.places, function(item){
                    if(that.orderby == 'countgroups') return (item[that.orderby][that.ordid] || {quantity: 0}).quantity;
                    return item[that.orderby];
                }, this.order),
                function(item) {
                    return (_.includes(that.status, item.status) || that.status.length == 0) && (_.intersection(that.selectedTags, item.tags).length > 0 || that.selectedTags.length == 0) && (item.name.toUpperCase().indexOf(that.namesearch.toUpperCase()) >= 0) 
                        && (item.customer_number.toUpperCase().indexOf(that.numbersearch.toUpperCase()) >= 0)
                        && (item.address_text != null && item.address_text.toUpperCase().indexOf(that.addressearch.toUpperCase()) >= 0)
                }
            );
        },
        customersList() {
            var groupos = _.groupBy(this.places, 'customer_id');
            var items = []
            for( var group_id in groupos){
                items.push({"id": group_id, "name": _.first(groupos[group_id]).customer_name, "status": "active", "places": groupos[group_id]})
            }
            return items;
        },
        overdone(){
            return function(datetime){
                return moment(datetime).unix() < moment().unix(); 
            }   
        }
    },
    mixins: [Vue2Filters.mixin],
}
</script>
<style scoped>
.login_button {
    color: red;
}

p {
    margin: 0em;
}

.selectorignored select {
    display: block;
}

.maincontainer {
    margin: 33px;
}

thead {
    background-color: #DADADA;
}

thead th {
    font-weight: 300;
    padding-top: 5px;
    padding-bottom: 5px;
}

th span {
    padding-left: 5px;
}

td {
    padding-left: 15px;
}

thead .input-field {
    margin-top: unset;
    margin-bottom: unset;
}

/deep/ div.select-wrapper {
    color: red;
    margin-left: 0px !important;
}

a {
    color: black;
}

/deep/ .vue-daterange-picker>div {
    border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
    border-radius: 5px;
    margin-bottom: 8px;
}

/deep/ .reportrange-text {
    padding-left: 5px !important;
    padding-top: 7px !important;
    padding-bottom: 7px !important;
}
.grayed {
    color: #BEBBBB !important;
}
.grayed a{
    color: #BEBBBB !important;
}
.overdue {
    color: red;
}
</style>
